import { render } from "./menu-h-item.vue?vue&type=template&id=53bf19a4"
import script from "./menu-h-item.vue?vue&type=script&lang=ts"
export * from "./menu-h-item.vue?vue&type=script&lang=ts"

import "./menu-h-item.vue?vue&type=style&index=0&id=53bf19a4&lang=css"
script.render = render

export default script